import { useState } from "react";
import { useDispatch } from "react-redux";
import { setMessage, setProfil } from "../../redux";
import "./style.css"

function Login() {
    const dispatch = useDispatch();
    const [form, setForm] = useState({ email: '', password: '' });
    const [save, setSave] = useState(localStorage.getItem('save_login'));

    const login = async (e) => {
        e.preventDefault();
        dispatch(setMessage('Chargement en cours, merci de patienter'));

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        })
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            alert(res.message)
            return
        }

        // Session storage
        sessionStorage.setItem('status', res.status);
        sessionStorage.setItem('token', res.token);
        sessionStorage.setItem('email', form.email);
        sessionStorage.setItem('password', form.password);

        // Local storage
        if (save) {
            localStorage.setItem('email', form.email);
            localStorage.setItem('password', form.password);
        }
        else {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
        }
        localStorage.setItem('save_login', save);

        // State
        const { token, ...resFiltered } = res;
        dispatch(setProfil(resFiltered));
    }

    return (
        <form className="form_login" onSubmit={login}>
            <h1>Se connecter</h1>

            <div className="blocks">
                <div className="inp_block">
                    <label>email</label>
                    <input type="text" value={form.email} onChange={(e) => setForm({ email: e.target.value, password: form.password })} />
                </div>

                <div className="inp_block">
                    <label>password</label>
                    <input type="password" value={form.password} onChange={(e) => setForm({ email: form.email, password: e.target.value })} />
                </div>
            </div>

            <div className="options">
                <button className="save_login" onClick={() => setSave(!save)} type="button"><i>{save ? '✔' : ''}</i> Se souvenir de moi</button>
                <button className="forget_pw" type="button" disabled>Mot de passe oublié ?</button>
            </div>

            <button className="btn_submit" type="submit">Se connecter</button>
        </form>
    )
}

export default Login;